import { createRouter, createWebHistory } from "vue-router";

import i18n from "../i18n";

import routes from "./routes";
import store from "../store";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

function isRoute(route, name) {
  return route.name === name;
}

router.beforeEach((to, from, next) => {
  let nextName = null;

  if (store.getters["user/isLoggedIn"]) {
    // User is logged-in

    if (to.name === "notFound") {
      // 404
      next({ name: "profile" });
      nextName = "profile";
    } else if (isRoute(to, "emailAction")) {
      next();
      nextName = to.name;
    } else if (
      !store.getters["user/isEmailVerified"] &&
      !isRoute(to, "account.verifyEmailAddress")
    ) {
      next({ name: "account.verifyEmailAddress" });
      nextName = "account.verifyEmailAddress";
    } else if (isRoute(to, "adminArea") && !store.getters["user/isAdmin"]) {
      next({ name: "profile" });
      nextName = "profile";
    } else if (
      isRoute(to, "account.login") ||
      isRoute(to, "account.register") ||
      isRoute(to, "account.passwordReset")
    ) {
      // User wants to access ressource that is only for logged-out users
      next({ name: "profile" });
      nextName = "profile";
    } else if (
      store.getters["user/isEmailVerified"] &&
      isRoute(to, "account.verifyEmailAddress")
    ) {
      next({ name: "profile" });
      nextName = "profile";
    } else {
      next();
      nextName = to.name;
    }
  } else {
    // User is not logged-in

    if (to.name === "notFound") {
      // 404
      next({ name: "profile" });
      nextName = "profile";
    } else if (
      !isRoute(to, "account.login") &&
      !isRoute(to, "account.register") &&
      !isRoute(to, "account.passwordReset") &&
      !isRoute(to, "licenses") &&
      !isRoute(to, "emailAction")
    ) {
      // User wants to access ressource that is only for logged-in users
      next({ name: "account.login" });
      nextName = "account.login";
    } else {
      next();
      nextName = to.name;
    }
  }

  let hasValue = false;
  let i = 0;
  while (!hasValue) {
    i++;
    if (i === 5) {
      hasValue = true;
    } else if (
      i18n.global.t(`pageTitle.${nextName}`) !== `pageTitle.${nextName}`
    ) {
      nextName = `pageTitle.${nextName}`;
      hasValue = true;
    } else if (i18n.global.t(nextName).includes(".")) {
      nextName = nextName.split(".")[0];
    } else {
      hasValue = true;
    }
  }

  if (i < 5) {
    const pageTitle = `${i18n.global
      .t(nextName)
      .charAt(0)
      .toUpperCase()}${i18n.global.t(nextName).slice(1)}`;
    document.title = `${pageTitle} - NOS`;
  } else {
    document.title = "Numbers of Success";
  }
});

export default router;
